export default __webpack_public_path__ + "static/media/finance3.6e17976a.mp4";